import { Injectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class BrowserService {
  private readonly document = inject<Document>(DOCUMENT);

  private get htmlElement(): HTMLElement | null {
    return this.document.querySelector('html');
  }

  public setHtmlElementClass(classNames: string | string[]): void {
    if (typeof classNames === 'string') {
      classNames = [classNames];
    }

    classNames.forEach(className => {
      if (!this.htmlElement?.classList.contains(className)) {
        this.htmlElement?.classList.add(className);
      }
    });
  }

  public removeHtmlElementClass(classNames: string | string[]): void {
    if (typeof classNames === 'string') {
      classNames = [classNames];
    }

    classNames.forEach(className => {
      if (this.htmlElement?.classList.contains(className)) {
        this.htmlElement?.classList.remove(className);
      }
    });
  }
}
